export abstract class BaseModel {
    public id: any;
    public totalPages: number | undefined;
    public totalElements: number | undefined;

    public constructor() { }
}
